import ActionTypePlan from "../ActionTypePlan";
// import {ModosOp} from '../../Constantes'
// import Estado from '../EstadoDialogoClienteAFacturar'

export default class CargaDeErroresDelDominioAlActualizarPlan extends ActionTypePlan {

    ejecutar(estado, nuevoEstado) {

        for (const property in nuevoEstado.error) {
            nuevoEstado.error[property]=false;
        }

        this.payload.errores.forEach( (error) => {
            nuevoEstado.error[error]=true;
        });

        nuevoEstado.flag.procesandoComando = false;
        return nuevoEstado;
    }

}